import { useMemo, useState } from "react";
import { emailRegex, normalizaEmail } from "../utils/strings";

type UseEmailListArgs = {
  correosFijos?: string[];
  correosExtra?: string[];
  onChangeCorreosExtra?: (extra: string[]) => void;
};

export const useEmailList = ({
  correosFijos = [],
  correosExtra = [],
  onChangeCorreosExtra,
}: UseEmailListArgs) => {
  const fijos = useMemo(() => correosFijos.map(normalizaEmail), [correosFijos]);
  const extra = useMemo(() => correosExtra.map(normalizaEmail), [correosExtra]);

  const [correoActual, setCorreoActual] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);

  const correosCombinados = useMemo(() => [...fijos, ...extra], [fijos, extra]);

  const tryAddEmail = () => {
    const e = normalizaEmail(correoActual);
    if (!e) return;
    if (!emailRegex.test(e)) {
      setEmailError("Correo inválido");
      return;
    }
    if (fijos.includes(e) || extra.includes(e)) {
      setEmailError("Ese correo ya fue agregado");
      return;
    }
    onChangeCorreosExtra?.([...(correosExtra ?? []), e]);
    setCorreoActual("");
    setEmailError(null);
  };

  const handleEliminarCorreo = (c: string) => {
    onChangeCorreosExtra?.((correosExtra ?? []).filter((x) => x !== c));
  };

  const handleKeyDownEmail: React.KeyboardEventHandler<HTMLInputElement> = (
    ev
  ) => {
    if (["Enter", "Tab", ","].includes(ev.key)) {
      ev.preventDefault();
      tryAddEmail();
    }
  };

  return {
    // data
    fijos,
    extra,
    correosCombinados,
    // input state
    correoActual,
    setCorreoActual,
    emailError,
    setEmailError,
    // actions
    tryAddEmail,
    handleEliminarCorreo,
    handleKeyDownEmail,
  };
};
